import React from 'react';
import { useApp } from '../context/AppContext';
import { howImages } from '../mock/mock';

const HowItWorks = () => {
  const { t } = useApp();
  const steps = t('how.steps');
  return (
    <section className="py-20 brand-gradient">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-3xl mb-14">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white">{t('how.title')}</h2>
          <p className="mt-4 text-white/70 leading-relaxed">{t('how.subtitle')}</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6">
          {(Array.isArray(steps) ? steps : []).map((s, i) => (
            <div key={i} className="card-hover bg-white/5 backdrop-blur border border-white/10 rounded-2xl overflow-hidden">
              <div className="relative h-44">
                <img src={howImages[i]} alt={s} className="w-full h-full object-cover" />
                <div className="absolute top-3 left-3 w-9 h-9 rounded-full flex items-center justify-center font-extrabold text-sm text-white" style={{ backgroundColor: 'var(--brand-accent)' }}>{i + 1}</div>
              </div>
              <div className="p-5">
                <h3 className="font-bold text-white">{s}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
